<template>
  <div class="main-wrapper invoice-page innerpagebg">
    <layouts-header></layouts-header>

    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 offset-md-1 col-md-10 col-lg-10">
            <div class="card">
              <div class="head d-flex justify-content-between align-items-center">
                <router-link
                  to="/index"
                  class="navbar-brand logo d-flex align-items-center"
                >
                  <img src="@/assets/img/logo-black.svg" class="img-fluid" alt="Logo" />
                </router-link>
                <div class="head-info text-end">
                  <h4 class="text-uppercase">INVOICE</h4>
                  <h5>DreamSports</h5>
                  <p class="mb-0">REG: 123000123000</p>
                  <p class="mb-0">dreamsports@example.com | +64 123 1234 123</p>
                </div>
              </div>
              <hr />
              <div class="dull-bg from-to">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                    <h5>From</h5>
                    <p class="mb-0">Joseph</p>
                    <p class="mb-0">45, 5th Street Newyork, USA</p>
                    <p class="mb-0">LX6457</p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                    <h5>To</h5>
                    <p class="mb-0">Yaseer</p>
                    <p class="mb-0">778 Mittal street, Germany</p>
                    <p class="mb-0">454787</p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                    <table class="short-info w-100">
                      <tr>
                        <td>INVOICE NUMBER:</td>
                        <td class="text-end">INV-0002</td>
                      </tr>
                      <tr>
                        <td>INVOICE DATE:</td>
                        <td class="text-end">02 Jan 2023</td>
                      </tr>
                      <tr>
                        <td>DUE:</td>
                        <td class="text-end">20 Jan 2023</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="invoice-table table table-bordered">
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Qty</th>
                      <th>Price</th>
                      <th>GST</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Product name</td>
                      <td>1</td>
                      <td>2000.00</td>
                      <td>0.00</td>
                      <td>2,000.00</td>
                    </tr>
                    <tr>
                      <td>Product name</td>
                      <td>1</td>
                      <td>2000.00</td>
                      <td>0.00</td>
                      <td>2,000.00</td>
                    </tr>
                    <tr>
                      <td>Product name</td>
                      <td>1</td>
                      <td>2000.00</td>
                      <td>0.00</td>
                      <td>2,000.00</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Total -->
              <div class="row">
                <div class="col-sm-12 col-md-7 col-xl-7 ms-auto">
                  <div class="dull-bg total-wrap table-responsive">
                    <table class="table-responsive table total">
                      <tbody>
                        <tr>
                          <td><h6>Sub Total (excl. GST)</h6></td>
                          <td class="text-end"><h6>$6,000.00</h6></td>
                        </tr>
                        <tr>
                          <td><h6>Total GST:</h6></td>
                          <td class="text-end"><h6>$0.00</h6></td>
                        </tr>
                        <tr>
                          <td><h6>Credit card fee (if using):</h6></td>
                          <td class="text-end"><h6>$92.00</h6></td>
                        </tr>
                        <tr>
                          <td><h6>Amount due on 20 Jan 2023:</h6></td>
                          <td class="text-end"><h6>6,092.00 USD</h6></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- /Total -->

              <div
                class="payment-detail d-flex justify-content-between align-items-center"
              >
                <div>
                  <h6 class="text-uppercase primary-text">PAYMENT INSTRUCTIONS</h6>
                  <h5 class="mb-0">DreamSports</h5>
                  <p class="mb-0">Bank name: ABC Bank limited</p>
                  <p class="mb-0">SWIFT/IBAN: NZ0201230012</p>
                  <p>Account number: 12-1234-123456-12</p>
                  <p class="mb-0">
                    Please use as INV-0002 as a reference number<br />
                    For any questions please contact us at dreamsports@example.com
                  </p>
                </div>
                <div class="">
                  <h5>Pay Online</h5>
                  <router-link
                    to="/index"
                    class="navbar-brand logo d-flex align-items-center justify-content-center"
                  >
                    <img
                      src="@/assets/img/pay-online.jpg"
                      class="img-fluid"
                      alt="Scanner"
                    />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
export default {
  data() {
    return {
      title: "User Bookings",
      text: "Home",
      text1: "User Bookings",
    };
  },
};
</script>
